import { css, keyframes } from "styled-components";

const loadingAnimation = keyframes`
	0%{background-position:0% 0%}
	100%{background-position:89% 89%}
`;

export interface BiColor {
	color1: string;
	color2: string;
}

export const animatedSkeletonStyle = css<{ biColor?: BiColor }>`
	background: ${({ biColor, theme }) =>
		biColor
			? `linear-gradient(313deg, ${biColor.color1}, ${biColor.color2}, ${biColor.color1}, ${biColor.color2})`
			: `linear-gradient(313deg, ${theme.colors.lightergray}, ${theme.colors.white}, ${theme.colors.lightergray}, ${theme.colors.white})`};
	background-position: 100% 100%;
	background-size: 400% 400%;
	animation: ${loadingAnimation} ease-in-out infinite 1s;
`;
